var hotelDescriptionText = vueIfExists({
	mixins: [win.toggleCollapse],
	el: '#hotel-description-text'
});

var hotelDescriptionDetails = vueIfExists({
	el: '#hotel-description-details'
});